import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SobreComponent } from './sobre/sobre.component';
import { LoginComponent } from './login/login.component';
import { ListaOrdemServicoComponent } from './lista-ordem-servico/lista-ordem-servico.component';
import { CriarOSComponent } from './criar-os/criar-os.component';
import { CriarOSEnderecoComponent } from './criar-osendereco/criar-osendereco.component';
import { CriarOSTipoOSComponent } from './criar-ostipo-os/criar-ostipo-os.component';
import { CriarOSClienteComponent } from './criar-oscliente/criar-oscliente.component';
import { ListaOsEncerradaComponent } from './lista-os-encerrada/lista-os-encerrada.component';
import { PrimeiroAcessoComponent } from './primeiro-acesso/primeiro-acesso.component';
import { CriarOSAtivoComponent } from './criar-osativo/criar-osativo.component';
import { EditarClienteComponent } from './editar-cliente/editar-cliente.component';
import {AuthGuard} from './guard';
import {CriarOSAmbienteComponent} from './criar-osambiente/criar-osambiente.component';

const routes: Routes = [
  { path:  '', redirectTo:  'listaOrdemServico', pathMatch:  'full' },
  { path:  'login',                component:  LoginComponent },
  { path:  'primeiroAcesso',       component:  PrimeiroAcessoComponent },
  { path:  'sobre',                component:  SobreComponent },
  { path:  'listaOrdemServico',    component:  ListaOrdemServicoComponent, canActivate: [AuthGuard] },
  { path:  'listaOsEncerrada',     component: ListaOsEncerradaComponent, canActivate: [AuthGuard] },
  { path:  'criarOS',                  component:  CriarOSComponent, canActivate: [AuthGuard] },
  { path:  'criarOSEnderecoComponent', component:  CriarOSEnderecoComponent, canActivate: [AuthGuard] },
  { path:  'criarOSAmbienteComponent', component:  CriarOSAmbienteComponent, canActivate: [AuthGuard] },
  { path:  'criarOSTipoOSComponent',   component:  CriarOSTipoOSComponent, canActivate: [AuthGuard] },
  { path:  'criarOSAtivoComponent',    component:  CriarOSAtivoComponent, canActivate: [AuthGuard] },
  { path:  'criarOSClienteComponent',  component:  CriarOSClienteComponent, canActivate: [AuthGuard] },
  { path:  'editarCliente',  component:  EditarClienteComponent, canActivate: [AuthGuard] },
  { path:  '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: true, useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
